import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  allResources: [],
  resource: {},
  resourcesBySite: [],
  customerResourceServices: [],
  updatedCustomerResourceServices: [],
  newResource: {},
  updatedResource: {},
  deletedResource: {},
  products: [],
  error: null,
  isLoading: false,
  enabledServices: [],
};

const resourceSlice = createSlice({
  name: 'resource',
  initialState,
  reducers: {
    start: (state, action) => {
      state.error = null;
      state.isLoading = true;
    },
    setReducerError: (state, action) => {
      state.error = action.error;
    },
    setProducts: (state, action) => {
      state.products = action.payload;
      state.error = null;
      state.isLoading = false;
    },
    setServices: (state, action) => {
      state.services = action.payload; // state not found
      state.isLoading = false;
    },
    setAllResources: (state, action) => {
      state.allResources = action.payload;
      state.isLoading = false;
      state.error = null;
    },
    setResource: (state, action) => {
      state.resource = action.payload;
      state.isLoading = false;
      state.error = null;
    },
    setCustomerResourceServices: (state, action) => {
      state.customerResourceServices = action.payload;
      state.isLoading = false;
      state.error = null;
    },
    setResourcesBySite: (state, action) => {
      state.resourcesBySite = action.payload;
      state.isLoading = false;
      state.error = null;
    },
    setNewResource: (state, action) => {
      state.newResource = action.payload;
      state.isLoading = false;
      state.error = null;
    },
    setUpdatedResource: (state, action) => {
      state.updatedResource = action.payload;
      state.isLoading = false;
      state.error = null;
    },
    setUpdatedCustomerResourceServices: (state, action) => {
      state.updatedCustomerResourceServices = action.payload;
      state.isLoading = false;
      state.error = null;
    },
    setDeletedResource: (state, action) => {
      state.deletedResource = action.payload;
      state.isLoading = false;
      state.error = null;
    },
    setResetResource: () => {
      return initialState;
    },
  },
});

export const {
  start,
  setReducerError,
  setProducts,
  setServices,
  setAllResources,
  setResource,
  setCustomerResourceServices,
  setResourcesBySite,
  setNewResource,
  setUpdatedResource,
  setUpdatedCustomerResourceServices,
  setDeletedResource,
  setResetResource,
} = resourceSlice.actions;

export default resourceSlice.reducer;
